module.exports = __webpack_public_path__ + "static/media/insorb-product-img@3x.afaa3527.png";